import React from 'react'
import { Copy as CopyIcon } from 'react-feather'
import PropTypes from 'prop-types'
import { Box, IconButton, Paper, Typography } from '@material-ui/core'

import useClipboard from 'hooks/useClipboard'

import theme from 'theme'
import useStyles from './styles'

import { getBaseAgeGateCdnUrl } from 'service/env'

const AgeGateCode = ({ ageGateToken }) => {
  const classes = useStyles()
  const { copy } = useClipboard()

  const baseAgeGateCdnUrl = getBaseAgeGateCdnUrl()
  const divCode = '<div id="age-gate"></div>'
  const scriptCode = `<script src="${baseAgeGateCdnUrl}/age_gates/${ageGateToken}/age_gate.js"></script>`

  const handleCodeCopying = () => copy(`${divCode}\n${scriptCode}`)

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Box>
        <Typography color="primary" variant="h6" gutterBottom>
          Código HTML de instalação do Age Gate
        </Typography>
      </Box>
      <Paper variant="outlined">
        <Box bgcolor={theme.palette.background.default}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" className={classes.divCodeTypography}>
              {divCode}
            </Typography>
            <Box height="fit-content">
              <IconButton
                size="small"
                className={classes.iconButton}
                onClick={handleCodeCopying}
              >
                <CopyIcon size={18} color={theme.palette.custom.superDark} />
              </IconButton>
            </Box>
          </Box>
          <Typography variant="body2" className={classes.scriptCodeTypography}>
            {scriptCode}
          </Typography>
        </Box>
      </Paper>
    </Box>
  )
}

AgeGateCode.propTypes = {
  ageGateToken: PropTypes.string,
}

export default AgeGateCode
